import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { contactTypesRoutes } from './contact-types.routing'
import { UpdateContactTypeComponent } from './update-contact-type/update-contact-type.component'
import { CreateContactTypeComponent } from './create-contact-type/create-contact-type.component'
import { ContactTypesComponent } from './contact-types.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    ContactTypesComponent,
    CreateContactTypeComponent,
    UpdateContactTypeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(contactTypesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    ContactTypesComponent,
    CreateContactTypeComponent,
    UpdateContactTypeComponent,
  ],
})
export class ContactTypesModule {}
